import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import AddToCartPopup from '../Components/AddToCartPopup';
import { hide } from '../Actions/AddToCartPopup.action';

class AddToCartPopupContainer extends Component {
    constructor(props) {
        super(props);

        this.settings = {
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 3,
            swipeToSlide: true,
            variableWidth: true,
            arrows: true,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        dots: true,
                        swipeToSlide: false,
                        touchMove: true,
                        variableWidth: true,
                    }
                },
                {
                    breakpoint: 530,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        dots: true,
                        swipeToSlide: false,
                        touchMove: true,
                        variableWidth: true,
                    }
                }
            ]
        }
    }

    
    render() {
        const ids = Object.keys(this.props.addToCartPopup.byId);
        const addToCartPopups = ids.map(id => ({ ...this.props.addToCartPopup.byId[id], id }));
        return <Fragment>
            {addToCartPopups && addToCartPopups.map(addToCartPopup => <AddToCartPopup key={addToCartPopup.id} model={addToCartPopup.relatedProductsModel} hide={() => this.props.hide(addToCartPopup.id)} settings={this.settings} showProduct={addToCartPopup.showProduct} />)}
        </Fragment>
    }
}

const mapStateToProps = state => {
    return {
        addToCartPopup: state.addToCartPopup,
    }
}

const mapDispatchToProps = {
    hide,
}

export default connect(mapStateToProps, mapDispatchToProps)(AddToCartPopupContainer);
